@if (visible) {
  <div class="modal_customer"
    >
    <div class="modal_customer_body">
      <div class="modal_text_md text-center">{{ title }}</div>
      <br>
        @if ( message.length > 0 ) {
          <div class="modal_text_sm text-center">
            {{ message }}
          </div>
        }
        <br>
        </div>
      </div>
    }
